import React, { ReactElement } from 'react'
import { EmptyState, EmptyStateProps } from './EmptyState'

export interface TableEmptyStateProps extends EmptyStateProps {
    children: string | ReactElement | ReactElement[]
}

export const TableEmptyState = ({ children, ...props }: TableEmptyStateProps): ReactElement => {
    return (
        <tr>
            <td colSpan={999}>
                <EmptyState {...props}>{children}</EmptyState>
            </td>
        </tr>
    )
}
